(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["custom-collection"]) return;
  try {
    

$('#custom-slider').owlCarousel({
    loop:false,
    margin:10,
    nav:false,
    dots: false,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive:{
        0:{
            items:2,
        },
        600:{
            items:2,
        },
        1000:{
            items:2,
			nav:true
        }
    }
})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
$('.swatches-container').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    dots: false,
    navText: ["<span class='left-arrow-custom'></span>", "<span class='right-arrow-custom'></span>"],
    responsive:{
        0:{
            items:3,
			dots: false
        },
        600:{
            items:3,
			dots:false
        },
        1000:{
            items:3
        }
    }
});
  
$('.mobile__product__slides').owlCarousel({
    loop:false,
    margin:10,
    nav:false,
    items:1,
   mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navText: ["<span class='left-arrow-custom'></span>", "<span class='right-arrow-custom'></span>"],
    responsive:{
        0:{
            items:1,
			dots: true
        },
        600:{
            items:1,
			dots:true
        },
        1000:{
            items:1
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rock-collection"]) return;
  try {
    

$('#custom-slider').owlCarousel({
    loop:false,
    margin:10,
    nav:false,
    dots: false,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive:{
        0:{
            items:2,
        },
        600:{
            items:2,
        },
        1000:{
            items:2,
			nav:true
        }
    }
})



  } catch(e) { console.error(e); }
})();

})();
